import React, { useRef, useLayoutEffect } from 'react';
import { sum, maxBy } from 'lodash';
import F2 from '@antv/f2';
import PieLabel from '@antv/f2/lib/plugin/pie-label';

import './pieChart.less'

interface PieChartProp {
  data: { label: string; value: number }[];
  onDataUrl: any,
  className?: string,
  unitText?: string,
  guideHtml?: (data: any) => string,
  colors?: string[],
}

function renderPieChart({ node, container, data, unitText, guideHtml, colors }) {
  const total = sum(data.map(({ value }) => value));
  const maxData = maxBy(data, 'value');
  const chart: any = new F2.Chart({
    el: node,
    pixelRatio: window.devicePixelRatio,
    plugins: PieLabel,
    animate: false,
    padding: [40, 0, 40, 0], // 分别设置上、右、下、左边距
  });
  chart.source(data);
  chart.coord('polar', {
    transposed: true,
    radius: 0.9,
    innerRadius: 0.5,
  });
  chart.axis(false);
  chart.legend(false);
  chart.tooltip(false);
  if (typeof guideHtml === 'function') {
    const html = guideHtml({
      total,
      maxData,
    })
    if (typeof html === 'string') {
      const guideNodes = container.getElementsByClassName('guideWapper')
      if (guideNodes) {
        [...guideNodes].forEach((guideNode) => {
          guideNode.parentNode.removeChild(guideNode)
        })
      }
      chart.guide().html({
        position: ['50%', '50%'],
        html: html,
      });
    }
  }
  chart.interval().position('const*value').adjust('stack').color('label', colors);
  chart.pieLabel({
    anchorOffset: 4,
    inflectionOffset: 18,
    // sidePadding: 100,
    activeShape: true,
    label1: function label1(data3) {
      return {
        text: `${data3.label} ${data3.value}${unitText}`,
        fill: '#666F80',
      };
    },
    label2: function label2(data2) {
      return {
        text: `${((data2.value / total) * 100).toFixed(2)}%`,
        fill: '#666F80',
      };
    },
  });
  chart.render();
  return chart
}

export const PieChart: React.FC<PieChartProp> = (props) => {
  const {
    data: initDate = [],
    onDataUrl,
    className = '',
    unitText = '',
    guideHtml,
    colors,
  } = props;
  const nodeRef: React.RefObject<HTMLCanvasElement> | null = useRef(null);
  const divRef: React.RefObject<HTMLDivElement> | null = useRef(null);
  useLayoutEffect(() => {
    const chart = renderPieChart({
      node: nodeRef.current,
      container: divRef.current,
      data:
        // orderBy(
        initDate.map(({ label, value }) => {
          return {
            const: 'const',
            label,
            value,
          };
        }),
      // ['value'], ['desc']),
      unitText,
      guideHtml,
      colors,
    })
    setTimeout(() => {
      onDataUrl(chart)
    }, 500)
  }, [initDate, onDataUrl]);
  return (
    <div className={`star-piechart ${className}`} ref={divRef} style={{ width: 500, height: 240 }}>
      <canvas className="piechart-canvas" ref={nodeRef} />
    </div>
  );
};

export default React.memo(PieChart);
